import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    className?: string;
    children: ReactNode;
}
/**
 * This component is used to wrap blocks in setting pages to add padding.
 * Settings list items should not have padding so this component makes it
 * easier to wrap items that should have padding in a settings page.
 */
const SettingsBlock = ({ className, children }: Props) => (
    <div className={twMerge('w-full', className)}>{children}</div>
);

export default SettingsBlock;
